import { IFilterDefinition, IFilterValues, TFilterOptions } from '@evinced-private/ui-common';

import { MANAGE_COLLECTIONS_FILTERS_ID } from '../../../consts/PropertyCollection';
import { CollectionTypeLabels, CollectionTypes } from '../../../interfaces/Collection';
import { CommonFiltersStore } from '../../../stores/CommonFiltersStore';

export const filterDefinitions: IFilterDefinition[] = [
	{
		id: 'searchValue',
		label: 'Search collections',
		filterType: 'text',
		defaultValue: '',
		componentProps: {}
	},
	{
		id: 'collectionTypes',
		label: 'Select Collection type',
		filterType: 'select',
		defaultValue: [],
		componentProps: {
			id: 'collectionTypes',
			label: 'Collection type',
			isMultiple: true,
			placeholder: 'Select Collection type',
			listboxWidth: '160px',
			allSelectedPlaceholder: 'All types',
			someItemsSelectedText: (count: number) => `Collection type (${count})`
		}
	}
];

export const getInitialFilterValues = (store: CommonFiltersStore): IFilterValues => {
	const filterValues = store.getFilterValue(MANAGE_COLLECTIONS_FILTERS_ID);

	return {
		text: { searchValue: filterValues?.searchValue },
		select: {
			collectionTypes: filterValues?.collectionTypes || []
		}
	};
};

export const getInitialFilterOptions = (): TFilterOptions => {
	return {
		collectionTypes: [
			{
				label: CollectionTypeLabels.TENANT,
				value: CollectionTypes.TENANT
			},
			{
				label: CollectionTypeLabels.USER,
				value: CollectionTypes.USER
			}
		]
	};
};
